import { FC, ReactNode } from 'react';
import { OptionsCalculatorCanvasConfig } from 'types/optionsCalculator';
import { OptionsCalculatorProviderBase } from './OptionsCalculatorContextProvider';
import useOptionsCalculatorCanvasState from './useOptionsCalculatorCanvasState';

interface CanvasOptionsCalculatorProviderProps {
  children: ReactNode;
  sym: string;
  onSymChange: (newSym: string) => void;
  config: OptionsCalculatorCanvasConfig;
  onConfigChange: (patch: Partial<OptionsCalculatorCanvasConfig>) => void;
}

/**
 * Canvas entry point: backs the calculator with per-instance state stored on
 * the component's own config, so multiple calculators can coexist on one
 * workspace. Mirrors `OptionsCalculatorProvider` (the standalone-page entry
 * point), which instead backs it with URL query state.
 */
export const CanvasOptionsCalculatorProvider: FC<
  CanvasOptionsCalculatorProviderProps
> = ({ children, sym, onSymChange, config, onConfigChange }) => {
  const state = useOptionsCalculatorCanvasState(
    sym,
    onSymChange,
    config,
    onConfigChange,
  );
  return (
    <OptionsCalculatorProviderBase state={state}>
      {children}
    </OptionsCalculatorProviderBase>
  );
};
